import { render } from "./Tutorial2.vue?vue&type=template&id=ac179494&scoped=true"
import script from "./Tutorial2.vue?vue&type=script&lang=js"
export * from "./Tutorial2.vue?vue&type=script&lang=js"

import "./Tutorial2.vue?vue&type=style&index=0&id=ac179494&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac179494"]])

export default __exports__